import { createSelector } from 'reselect';
import includes from 'array-includes';

const renderingAlias = ['render', 'panorama'];
const widgetAlias = [
  'widget_publish_plan',
  'widget_publish_top',
  'widget_publish_three_quarter',
  'widget_publish_rotate_360',
  'widget_publish_virtual_tour',
];

export const selectUserData = createSelector(
  (state) => state.common,
  (common) => common
);

export const selectUserGoods = createSelector(selectUserData, (data) => data.goods.filter((item) => item.count > 0));

export const selectUserPricing = createSelector(selectUserData, (data) => data.pricing);

export const selectAllPricing = createSelector(selectUserData, (data) => data.allPricing);

export const selectRenderingGoods = createSelector(selectUserData, (data) =>
  data.goods.filter((item) => includes(renderingAlias, item.alias))
);

export const selectWidgetsGoods = createSelector(selectUserData, (data) =>
  data.goods.filter((item) => includes(widgetAlias, item.alias))
);

export const selectAllGoods = createSelector(selectUserData, (data) => data.goods);

export const selectTeam = createSelector(
  selectUserData,
  (data) => data.teams.find((item) => item.id === data.currentTeam) || ''
);
export const selectTeams = createSelector(selectUserData, (data) => data.teams);

export const selectNameAndAvatar = createSelector(selectUserData, selectTeam, (data, team) => ({
  username: team ? team.caption || 'Team ' + team.id : data.username,
  avatar: team ? team.avatar : data.avatar,
  locale: team ? team.locale : data.locale,
}));

export const selectTeamLicenses = createSelector(selectUserData, selectTeam, (data, team) => {
  if (team) {
    return {
      licenseCount: data.licenseCount,
      licenseExpire: data.licenseExpire,
    };
  } else {
    return {
      licenseExpire: data.tariff.expire,
    };
  }
});

export const selectCurrentTeamFull = createSelector(selectUserData, (data) => data.currentTeamFull);

export const selectUserWorkMode = createSelector(selectUserData, (data) => data.workMode);

export const selectLoader = createSelector(selectUserData, (data) => data.fetching);

export const selectLocale = createSelector(selectUserData, (data) => data.locale);

export const selectPaymentOptions = createSelector(
  (state) => state.paymentOptions,
  (paymentOptions) => paymentOptions
);

export const selectProcessing = createSelector(selectUserData, (data) => data.processing);
